import { observer } from 'mobx-react-lite';
import PaddingMarginsPanel from './PaddingMarginsPanel';
import type { PaddingMarginsPanelProps, PaddingMarginsPanelValueProps } from './types';

export type { PaddingMarginsPanelProps, PaddingMarginsPanelValueProps };
export default observer(PaddingMarginsPanel); // MANUAL OVERRIDE
